export default "__VITE_ASSET__kFUl6swH__"